import { useCountry } from "../context/CountryContext";

// Inline SVG flags: emoji flags don't render on Windows (they show up as the letters "GB" and "NG")
function UkFlag() {
  return (
    <svg className="cty-flag" viewBox="0 0 60 30" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <clipPath id="uk-flag-a">
        <path d="M0,0 v30 h60 v-30 z" />
      </clipPath>
      <clipPath id="uk-flag-b">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z" />
      </clipPath>
      <g clipPath="url(#uk-flag-a)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169" />
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6" />
        <path d="M0,0 L60,30 M60,0 L0,30" clipPath="url(#uk-flag-b)" stroke="#C8102E" strokeWidth="4" />
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10" />
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6" />
      </g>
    </svg>
  );
}

function NigeriaFlag() {
  return (
    <svg className="cty-flag" viewBox="0 0 60 30" preserveAspectRatio="none" aria-hidden="true" focusable="false">
      <rect width="20" height="30" fill="#008751" />
      <rect x="20" width="20" height="30" fill="#ffffff" />
      <rect x="40" width="20" height="30" fill="#008751" />
    </svg>
  );
}

const OPTIONS = [
  { code: "UK", label: "United Kingdom", Flag: UkFlag },
  { code: "Nigeria", label: "Nigeria", Flag: NigeriaFlag },
];

export default function CountryToggle({ compact = false }) {
  const { country, setCountry } = useCountry();

  return (
    <div
      className={`cty${compact ? " cty--compact" : ""}`}
      role="group"
      aria-label="Choose your country"
    >
      {OPTIONS.map(({ code, label, Flag }) => (
        <button
          key={code}
          type="button"
          className={`cty-btn${country === code ? " is-active" : ""}`}
          aria-pressed={country === code}
          aria-label={label}
          title={label}
          onClick={() => setCountry(code)}
        >
          <Flag />
        </button>
      ))}
    </div>
  );
}